import React, { useEffect, useState } from "react";
import ReactLoading from "react-loading";
import { IoMdClose } from "react-icons/io";
import { MdArrowForwardIos } from "react-icons/md";
import { IoIosArrowForward } from "react-icons/io";
import { IoMdHome } from "react-icons/io";
import { MdWork } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";
import select_circle from "../../Assets/Images/icons/select_rectangle.png"
import unselect_circle from "../../Assets/Images/icons/unselect_rectangle.png"
import { useNavigate } from "react-router-dom";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { RiEBikeFill } from "react-icons/ri";
import bell_icon from "../../Assets/Images/icons/bell_icon.png"
import door_icon from "../../Assets/Images/icons/door_icon.png"
import Avoid_call from "../../Assets/Images/icons/avoid_call_icon.png"
import gurard_icon from "../../Assets/Images/icons/guard_icon.png"
import pet_foot from "../../Assets/Images/icons/pet_foot_icon.png"
import { showToast } from "../toastConfig/ToastConfig";
import InstructionsNoteModal from "../Instructions_Note/InstructionsNoteModal";
import { FaRegSquarePlus, FaCircleCheck } from "react-icons/fa6";
import { IoChevronBack } from "react-icons/io5";
import axiosInstance, { Razorpay_Key } from "../../Services/axios";
import DeliveryTime_Slot from "../DeliveryTImeslot/DelivrySlot";
import { RiErrorWarningLine } from "react-icons/ri";
import { useCallback } from "react";
import useRazorpay from "react-razorpay";
import { changeOrderShippingType, fetchChangeDeliveryDetails, fetchVendorDeliverySettings, orderChangeDeliveryLocationsList, orderConfirmChangeDelivery, productUpdateDeliveryTimeDate } from "../../Services/api";


const ChangeDeliverytypeOffcanvas = ({ isOpen, toggleDeliveryTypeOffCanvas, data, openPaymentSuccessModal }) => {


    const navigate = useNavigate()
    let defaltDeliverytype = data?.shipping_type == 0 ? 1 : data?.shipping_type == 1 ? 0 : data?.shipping_type == 2 ? 1 || 0 : ""
    const [Razorpay] = useRazorpay();
    const [seletedDeliverytype, setSeletedDeliverytype] = useState(defaltDeliverytype);
    const [userLocationListModal, setUserLocationListModal] = useState(false);
    const [slotdeliveryModal, setSlotdeliveryModal] = useState(false)
    const [deliveryOptionModal, setDeliveryOptionModal] = useState(false);
    const [showDatePickerModal, setDatePickerModal] = useState(false);
    const [isDatePickerOffCanvasOpen, setDatePickerOffCanvasOpen] = useState(false);


    const [userLocation, setUserLocation] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState('');

    const [locationBtnloder, setLocationBtnloder] = useState(true);
    const [delivery_option, setDelivery_option] = useState(1);
    const [deliverySettings, setDeliverySettings] = useState();
    const [updatedDeliverydata, setUpdatedDeliverydata] = useState('');
    const [updatedDeliverypayment, setUpdatedDeliverypayment] = useState('');



    const [deliveryOptionList, setDeliveryOptionList] = useState([]);
    const [slotdeliveryOption, setslotdeliveryOption] = useState([]);

    const [deliverytype, setDeliverytype] = useState('');
    const [otherdeliveryoption, setOtherdeliveryoption] = useState(false);
    const [tipOption, setTipOption] = useState();
    const [deliverytipamt, setDeliveryTipamt] = useState('');
    const [instructionsOption, setInstructionsOption] = useState([]);
    const [showInstructionModal, setShowInstructionModal] = useState('');
    const [selectedTexts, setSelectedTexts] = useState("");
    const [recordedAudio, setRecordedAudio] = useState(null);
    const [consulation, setConsulation] = useState("");






    const handleTipSelection = (option, amount) => {
        if (tipOption == option) {
            setTipOption(null);
            setDeliveryTipamt(null);
        } else {
            setTipOption(option);
            setDeliveryTipamt(amount);
        }
    };

    const toggleshowInstruction = () => {
        setShowInstructionModal(!showInstructionModal);
    };

    const handleOptionToggle = (label) => {
        setInstructionsOption((prevOptions) => {
            const updatedOptions = prevOptions.includes(label)
                ? prevOptions.filter((option) => option !== label)
                : [...prevOptions, label];

            // Save to localStorage
            localStorage.setItem("deliveryInstructions", JSON.stringify(updatedOptions));

            return updatedOptions;
        });
        setSelectedTexts((prevOptions) =>
            prevOptions.includes(label)
                ? prevOptions.filter((option) => option !== label)
                : [...prevOptions, label]
        );
        // localStorage.setItem("deliveryInstructions", JSON.stringify(instructionsOption));
    };

    const toggleDatePickerOffCanvas = () => {
        let deliveryTime = localStorage.getItem("productDeliveryTime");
        if (deliveryTime) {
            setSlotdeliveryModal(!slotdeliveryModal)
            setDeliveryOptionModal(!deliveryOptionModal)
            updateInstore()

        }
        setDatePickerOffCanvasOpen(!isDatePickerOffCanvasOpen);
        setDatePickerModal(false)

    };

    const handelSelectTime = () => {
        setDatePickerModal(true);
        setDatePickerOffCanvasOpen(true);
    }

    const getUserLocationList = async () => {
        try {
            setLocationBtnloder(false)
            let reqData = {
                order_id: data?.order_id
            }
            const res = await orderChangeDeliveryLocationsList(reqData);

            if (res?.status == 200) {
                console.log('res data ', res);
                setLocationBtnloder(true)
                setUserLocationListModal(!userLocationListModal)
                setUserLocation(res?.data?.user_locations || [])
            }
        } catch (err) {
            if (err.response.status == 500 || err.response.status == 400) {
                showToast(err.response || "Something went wrong, please try again later");
            }
        }
    }

    const selectLocation = (location) => {
        setSelectedLocation(location)
        setUserLocationListModal(!userLocationListModal)
        fetchVendorDeliveryOptions(location)
    }


    const fetchVendorDeliveryOptions = async (location) => {
        // fetch_vendor_delivery_settings
        let reqData = {
            order_id: data?.order_id,
            delivery_address: location?.latlng
        };


        try {
            const res = await fetchVendorDeliverySettings(reqData);

            if (res.status == 200) {
                setDeliverySettings(res.data?.delivery_settings)
                // setSavedLoaction(res.data?.user_locations);
                // setLocationLoader(false);
                // setAddressDistance(res.data?.delivery_radius)
            }
        } catch (err) {
            if (err.response.status == 500 || err.response.status == 400) {
                showToast(err.response || "Something went wrong, please try again later");
            }
        }
    }

    const SelectSlotDelivery = async (type) => {
        try {

            let reqData = {
                "cart_id": data?.order_id,
                "order_delivery_time": ' ',
                "order_delivery_date": type,
            }

            let res = await productUpdateDeliveryTimeDate(reqData)
            if (res.status == 200) {
                setSlotdeliveryModal(false)
                setDeliveryOptionModal(false)
                fetchChangedetails()
            }
        } catch (err) {
            if (err.response.status == 500 || err.response.status == 400) {
                showToast(err.response || "Something went wrong, please try again later");
            }
        }
    }

    const updateInstore = async () => {
        try {
            const url = localStorage.getItem("recoredURL");
            const localTimeSlot = JSON.parse(localStorage.getItem("productDeliveryTime")) || {};

            const isDelivery = seletedDeliverytype == 2;

            const reqdata = {
                order_id: data?.order_id,
                shipping_type: seletedDeliverytype,
                delivery_address: isDelivery ? selectedLocation?.latlng : "",
                delivery_date: isDelivery ? (localTimeSlot.selectDate || deliverytype) : "",
                delivery_time: isDelivery ? localTimeSlot.selectHour : "",
                delivery_instructions: isDelivery ? selectedTexts : "",
                additional_notes: isDelivery ? consulation : "",
                voice_note: isDelivery ? url : "",
                delivery_tip: isDelivery ? deliverytipamt : "",
            };


            const res = await changeOrderShippingType(reqdata);

            if (res.status == 200) {
                if (isDelivery) {
                    setSlotdeliveryModal(false);
                    setDeliveryOptionModal(false);
                    fetchChangedetails();
                }

            }

        } catch (err) {
            if (err.response.status == 500 || err.response.status == 400) {
                showToast(err.response || "Something went wrong, please try again later");
            }
        }
    };

    const fetchChangedetails = async () => {
        let reqdata = {
            order_id: data?.order_id,
        };
        try {
            let res = await fetchChangeDeliveryDetails(reqdata);
            if (res.status == 200) {
                let changed_details = null;
                if (res.data?.change_delivery_details) {
                    changed_details = res.data?.change_delivery_details ?? null;
                    if (changed_details?.payment_data) {
                        try {
                            changed_details.payment_data = JSON.parse(changed_details.payment_data);
                        } catch (err) {
                            console.error("Invalid JSON in payment_data", err);
                        }
                    }
                }
                setUpdatedDeliverypayment(changed_details)
                setUpdatedDeliverydata(res.data)
            }

        } catch (err) {
            if (err.response.status == 500 || err.response.status == 400) {
                showToast(err.response || "Something went wrong, please try again later");
            }
        }

    };

    const confirmChangeDelivery = async () => {

        let url = localStorage.getItem('recoredURL')
        let localTimeSlot = JSON.parse(localStorage.getItem("productDeliveryTime"))
        const isDelivery = seletedDeliverytype == 2;
        try {

            let payload = {
                order_id: data?.order_id,
                shipping_type: seletedDeliverytype,
                delivery_address: isDelivery ? selectedLocation?.latlng : "",
                delivery_date: isDelivery ? (localTimeSlot.selectDate || deliverytype) : "",
                delivery_time: isDelivery ? localTimeSlot.selectHour : "",
                delivery_instructions: isDelivery ? selectedTexts : "",
                additional_notes: isDelivery ? consulation : "",
                voice_note: isDelivery ? url : "",
                delivery_tip: isDelivery ? deliverytipamt : "",
            };

            let res = await orderConfirmChangeDelivery(payload);
            if (res.status == 200) {
                let result = res.data;

                if (result?.payment_status == 1) {
                    handlePayment({ orderDetails: result?.payment_recipt })
                } else {
                    toggleDeliveryTypeOffCanvas()
                }
            }
        } catch (err) {
            if (err.response.status == 500 || err.response.status == 400) {
                showToast(err.response || "Something went wrong, please try again later");
            }
        }

    }

    const handlePayment = useCallback(
        (orderData) => {

            const createOrderAndInitializePayment = async () => {
                const options = {
                    key: Razorpay_Key,
                    amount: orderData?.orderDetails?.amount,
                    currency: orderData?.orderDetails?.currency,
                    name: "PINGLE",
                    description: "Payment",
                    image: "https://pingle.in/user/assets/images/LogoUser.png",
                    order_id: orderData?.orderDetails?.id,
                    handler: (res) => { 
                        if (res) {
                            openPaymentSuccessModal();
                            // onPayment(res); // Passing the order ID to the parent component
                        }
                    },
                    prefill: {
                        name: data?.user_detail?.user_name,
                        email: data?.user_detail?.user_email,
                        contact: data?.user_detail?.user_mbl,
                    },
                    theme: {
                        color: "#4E26A3",
                    },
                };

                const rzpay = new Razorpay(options);
                rzpay.open();
            };

            createOrderAndInitializePayment();
        },
        []
    );



    return (
        <>

            {isOpen &&
                <>
                    <div className="modalBackdrop change-backdrop" ></div>
                    <div className={`offcanvas offcanvas-bottom-modal change-modal ${isOpen ? 'show ' : ''}`}>
                        <div className=" ">
                            <div className="d-flex justify-content-between align-items-center">
                                <h6 className="ff-poppins-semiBold">Delivery Option</h6>
                                <div className="modalCloseicon" onClick={() => toggleDeliveryTypeOffCanvas()}>
                                    <IoMdClose />
                                </div>
                            </div>
                            <div className={`p-1 ${updatedDeliverypayment ? 'scroller-style-y' : ''}`}  >
                                <div className="d-flex flex-column ">
                                    {data?.shipping_type != 0 &&
                                        <div className={`${seletedDeliverytype == 0 ? "primary-box primary-text" : "secondary-box"} rounded-3 mt-2`} onClick={() => { setSeletedDeliverytype(0); updateInstore() }}>
                                            <div className="d-flex justify-content-between align-items-center p-2" >
                                                <div className="d-flex align-items-center">
                                                    {
                                                        seletedDeliverytype == 0 ?
                                                            <img src={select_circle} height="25px" width="25px" /> :
                                                            <img src={unselect_circle} height="25px" width="25px" />
                                                    }
                                                    <div className="ms-3">
                                                        <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">Dine-in Service</h6>
                                                        <p className="fs-10 p-0 m-0 ff-poppins-regular ">Hassle-free dine-in service available!</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {data?.shipping_type != 1 &&
                                        <div className={`${seletedDeliverytype == 1 ? "primary-box primary-text" : "secondary-box"} rounded-3 mt-2`} onClick={() => { setSeletedDeliverytype(1); updateInstore() }}>
                                            <div className="d-flex justify-content-between align-items-center p-2" >
                                                <div className="d-flex align-items-center">
                                                    {
                                                        seletedDeliverytype == 1 ?
                                                            <img src={select_circle} height="25px" width="25px" /> :
                                                            <img src={unselect_circle} height="25px" width="25px" />
                                                    }
                                                    <div className="ms-3">
                                                        <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">Instore Pickup</h6>
                                                        <p className="fs-10 p-0 m-0 ff-poppins-regular ">Hassle-free Instore service available!</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {data?.shipping_type != 2 &&
                                        <div className={`${seletedDeliverytype == 2 ? "primary-box primary-text" : "secondary-box"} rounded-3 mt-2`} onClick={() => setSeletedDeliverytype(2)}>
                                            <div className="d-flex justify-content-between align-items-center p-2" >
                                                <div className="d-flex align-items-center">
                                                    {
                                                        seletedDeliverytype == 2 ?
                                                            <img src={select_circle} height="25px" width="25px" /> :
                                                            <img src={unselect_circle} height="25px" width="25px" />
                                                    }
                                                    <div className="ms-3">
                                                        <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">Doorstep Delivery</h6>
                                                        <p className="fs-10 p-0 m-0 ff-poppins-regular ">Hassle-free doorstep service available!</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="primary-bg-light mt-2 text-center rounded-3">
                                    <span className="primary-text fs-20">  <RiErrorWarningLine /></span>
                                    <p className="px-3 py-2 m-0 fs-12 ff-poppins-medium text-center">Are you sure you want to change the delivery type from {""}
                                        {data?.shipping_type == 0 ? 'Dine-in' : data?.shipping_type == 1 ? 'Instore pickup' : data?.shipping_type == 2 ? 'Doorstop' : ""}
                                        {" "}    to {" "}
                                        {seletedDeliverytype == 0 ? 'Dine-in' : seletedDeliverytype == 1 ? 'Instore pickup' : seletedDeliverytype == 2 ? 'Doorstop' : ""}?
                                        Please note that packing charges will not be refundable.</p>
                                </div>
                                <div className="mt-2">
                                    {seletedDeliverytype == 2 &&
                                        <>
                                            <div className="mb-2">
                                                <div className="fs-14 ff-poppins-bold">
                                                    Delivery Address
                                                </div>
                                                {selectedLocation ? (

                                                    <div >
                                                    {/* // onClick={() => getuserlocationlist()} */}
                                                   

                                                        <div className={`border rounded d-flex p-2 mt-2`}>
                                                            <div className="col-2 ">
                                                                <div className="border w-100 border-black border-opacity-10 rounded d-flex justify-content-center mt-2 fs-24 primary-text py-2">
                                                                    {selectedLocation?.location_type_id == 1 ? (
                                                                        <IoMdHome className="primary-text" />
                                                                    ) : selectedLocation?.location_type_id == 2 ? (
                                                                        <MdWork className="primary-text" />
                                                                    ) : (
                                                                        <IoLocationSharp />
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="col-9">
                                                                <p className="m-0 ps-3 ff-poppins-bold">
                                                                    {selectedLocation?.location_type}{" "}
                                                                </p>
                                                                <p className="m-0 ps-3 ff-poppins-regular singleline-text fs-12">
                                                                    {selectedLocation?.address}
                                                                </p>
                                                                <p className="m-0 ps-3 ff-poppins-regular fs-12">
                                                                    {selectedLocation?.distance?.text} - {selectedLocation?.duration?.text}
                                                                </p>
                                                            </div>
                                                            <div className="col-1 ms-2 mt-3">
                                                                <IoIosArrowForward />
                                                            </div>
                                                        </div>
                                                    </div>

                                                ) : (
                                                    <button className="addAddressBtn" onClick={() => getUserLocationList()} >
                                                        {locationBtnloder ? "Add Address"
                                                            : <div className="d-flex justify-content-center">
                                                                <ReactLoading type={"spinningBubbles"} color={"#4E26A3"} style={{ height: 24, width: 24 }} />
                                                            </div>
                                                        } </button>
                                                )}
                                            </div>
                                            <div className="secondary-box rounded-3 mb-4">
                                                <div className="p-2">
                                                    <div className="secondary-bg-4 rounded-4" style={{ padding: '6px 8px', display: "flex", justifyContent: "center" }}>
                                                        <div className="Tab-container">
                                                            <div className="highlight" style={{ transform: `translateX(${(delivery_option - 1) * 100}%)` }} ></div>
                                                            <div className={`Tab-design fs-10 ff-poppins-semiBold ${delivery_option == 1 ? "text-white" : ""}`}
                                                                onClick={() => setDelivery_option(1)}>
                                                                Delivery Type
                                                            </div>
                                                            <div className={`Tab-design fs-10 ff-poppins-semiBold ${delivery_option == 2 ? "text-white" : ""}`}
                                                                onClick={() => setDelivery_option(2)}>
                                                                Tip
                                                            </div>
                                                            <div className={`Tab-design fs-10 ff-poppins-semiBold ${delivery_option == 3 ? "text-white" : ""}`}
                                                                onClick={() => setDelivery_option(3)}>
                                                                Instructions
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        delivery_option == 1 ?
                                                            <div className="mt-3">
                                                                {
                                                                    !updatedDeliverydata ?
                                                                        <div className="" onClick={() =>
                                                                            selectedLocation ?
                                                                                setDeliveryOptionModal(!deliveryOptionModal)
                                                                                : showToast("Please add a delivery address to continue")
                                                                        } >
                                                                            <div className="border border-black border-opacity-10 p-2 rounded-2 mt-2">
                                                                                <div className="d-flex align-items-center w-100">
                                                                                    <div className="border border-black border-opacity-10 rounded  d-flex justify-content-center align-items-center  primary-text"
                                                                                        style={{ width: "40px", height: "40px" }}
                                                                                    >
                                                                                        <RiEBikeFill size={20} />
                                                                                    </div>

                                                                                    <h6 className="fs-12 ff-poppins-semiBold primary-text ms-3 mb-0">
                                                                                        Choose delivery option
                                                                                    </h6>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        <div className="d-flex justify-content-between align-items-center secondary-box mt-2 mb-1 rounded-3 p-2">
                                                                            <div>
                                                                                {
                                                                                    updatedDeliverydata?.change_delivery_details?.delivery_date == 'Anytime' ?
                                                                                        <>
                                                                                            <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold">Any Time</h6>
                                                                                            <p className="p-0 m-0 fs-10 ff-poppins-regular">This product will be delivered within 3 days.</p>
                                                                                        </>
                                                                                        :
                                                                                        updatedDeliverydata?.change_delivery_details?.delivery_date == "instant" ?
                                                                                            <>
                                                                                                <h6 className="p-0 m-0 fs-12 ff-poppins-semiBold">Instant Delivery</h6>
                                                                                                <p className="p-0 m-0 fs-10 ff-poppins-regular">At your door in <span className="primary-text">30 minutes!</span></p>
                                                                                            </> :
                                                                                            <>
                                                                                                <h6 className="p-0 m-0 fs-12  ff-poppins-semiBold">Slot Delivery</h6>
                                                                                                <p className="p-0 m-0 fs-10  ff-poppins-regular">Slot delivery, at your door on time!</p>
                                                                                                <p className="p-0 m-0 fs-10  ff-poppins-medium primary-text">
                                                                                                    {updatedDeliverydata?.change_delivery_details?.delivery_date}
                                                                                                    {" "} {new Date(updatedDeliverydata?.change_delivery_details?.delivery_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                                                                                                </p>
                                                                                            </>
                                                                                }
                                                                            </div>


                                                                            <div>
                                                                                <p className="m-0 d-flex justify-content-end primary-text ff-poppins-semiBold fs-14" onClick={() => { setDeliveryOptionModal(!deliveryOptionModal) }}>Change</p>
                                                                            </div>

                                                                        </div>}
                                                            </div>
                                                            :
                                                            delivery_option == 2 ?
                                                                <div className="mt-3 ">
                                                                    <div>
                                                                        <p className="text-center fs-11 p-0 m-0  ff-poppins-regular  secondary-text-1 ">Rain or shine,delivery partner bring your favorite meals.<br /> show them same love with tip!</p>

                                                                        <div className={`d-flex justify-content-between mt-3 ${tipOption == 4 ? "" : "mb-3"}`} >
                                                                            <div
                                                                                className={`${tipOption === 1 ? "select-tip-box" : "tip-box"} d-flex align-items-center justify-content-center`}
                                                                                onClick={() => handleTipSelection(1, 20)}   >
                                                                                <span className="d-flex align-items-center">
                                                                                    <FaIndianRupeeSign size={10} />
                                                                                    <span>20</span>
                                                                                </span>
                                                                                {tipOption === 1 && <IoMdClose className="ms-2" />}
                                                                            </div>
                                                                            <div
                                                                                className={`${tipOption == 2 ? "select-tip-box" : "tip-box"} d-flex align-items-center justify-content-center`}
                                                                                onClick={() => handleTipSelection(2, 30)}      >
                                                                                <span className="d-flex align-items-center">
                                                                                    <FaIndianRupeeSign size={10} />
                                                                                    <span>30</span>
                                                                                </span>
                                                                                {tipOption == 2 && <IoMdClose className="ms-2" />}
                                                                            </div>
                                                                            <div
                                                                                className={`${tipOption == 3 ? "select-tip-box" : "tip-box"} d-flex align-items-center justify-content-center`}
                                                                                onClick={() => handleTipSelection(3, 50)} >
                                                                                <span className="d-flex align-items-center">
                                                                                    <FaIndianRupeeSign size={10} />
                                                                                    <span>50</span>
                                                                                </span>
                                                                                {tipOption == 3 && <IoMdClose className="ms-2" />}
                                                                            </div>
                                                                            <div
                                                                                className={`${tipOption == 4 ? "select-tip-box" : "tip-box"}  d-flex align-items-center justify-content-center gap-1`}
                                                                                onClick={() => handleTipSelection(4,)} >
                                                                                <span>{tipOption == 4} Other</span>
                                                                                {tipOption == 4 && <IoMdClose className="" size={16} />}
                                                                            </div>
                                                                        </div>

                                                                        {
                                                                            tipOption == 4 &&
                                                                            <div className="mt-2 w-100 text-center d-flex justify-content-center align-items-center mb-3">
                                                                                <span style={{ fontSize: '14px', fontWeight: '500' }}>₹</span>

                                                                                <input
                                                                                    type="text"
                                                                                    placeholder="Enter tip amount"
                                                                                    maxLength={3}
                                                                                    value={deliverytipamt}
                                                                                    onChange={(e) => {
                                                                                        const numericValue = e.target.value.replace(/\D/g, "");
                                                                                        setDeliveryTipamt(numericValue);
                                                                                    }}

                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === "Enter") {
                                                                                            e.target.blur(); // ✅ closes mobile keyboard
                                                                                        }
                                                                                    }}

                                                                                    className="tip-amount-input text-left ff-poppins-semiBold fs-13"
                                                                                    style={{ padding: '2px 0px 2px 2px', width: '40%' }}
                                                                                />
                                                                            </div>
                                                                        }

                                                                    </div>
                                                                </div> :
                                                                delivery_option == 3 ?
                                                                    <div className="mt-3 cursorDefault">
                                                                        <div>
                                                                            <p className="text-center fs-11 p-0 m-0  ff-poppins-regular  secondary-text-1 ">Add delivery instructions for a smooth drop-off!</p>
                                                                            <div className=" d-flex  scroller-style-x ">

                                                                                <div className="d-flex mt-3 overflow-auto scroller-style-x">
                                                                                    {[
                                                                                        { id: 1, icon: bell_icon, label: "Don't ring the bell" },
                                                                                        { id: 2, icon: door_icon, label: "Leave at the door" },
                                                                                        { id: 3, icon: Avoid_call, label: "Avoid Calling" },
                                                                                        { id: 4, icon: gurard_icon, label: "Leave with guard" },
                                                                                        { id: 5, icon: pet_foot, label: "Pet at home" }
                                                                                    ].map((option) => (
                                                                                        <div
                                                                                            key={option.id}
                                                                                            className={`${instructionsOption.includes(option.label) ? "select-primary-box" : ""} Instructions-box mx-1`}
                                                                                            onClick={() => handleOptionToggle(option.label)}
                                                                                        >
                                                                                            <img src={option.icon} alt={option.label} className="instrctionIcons" />
                                                                                            <p className="fs-10 ff-poppins-semiBold p-0">{option.label}</p>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                            {recordedAudio || consulation ?
                                                                                <div className="addedInstructionContainer addedInstructionLarge d-flex justify-content-between align-items-center w-100 p-2 mt-1" onClick={() => toggleshowInstruction()} >
                                                                                    <div className="addedInstrcRight d-flex align-items-center gap-2">
                                                                                        <FaCircleCheck size={20} />
                                                                                        Instruction added
                                                                                    </div>
                                                                                    <div className="addedInstrcRight">
                                                                                        Edit
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                <div>
                                                                                    <p className="addInstructionNote" role="button" onClick={() => toggleshowInstruction()}>+ Add an instructions note</p>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    : ""
                                                    }
                                                </div>
                                            </div>

                                        </>
                                    }
                                    {
                                        updatedDeliverypayment &&
                                        <div>
                                            <div className="fs-12 ff-poppins-medium mb-2">
                                                <div className="d-flex justify-content-between ">
                                                    <p className="m-0 p-0">Delivery Charge</p>
                                                    <p className="m-0 p-0">{updatedDeliverypayment?.payment_data?.delivery_charge} </p>
                                                </div>
                                                {
                                                    deliverytipamt && deliverytipamt != 0 ?
                                                        <div className="d-flex justify-content-between ">
                                                            <p className="m-0 p-0">Delivery Tip</p>
                                                            <p className="m-0 p-0"> {Number(deliverytipamt)}.00 </p>
                                                        </div> : ""
                                                }

                                                {
                                                    updatedDeliverypayment?.payment_data?.packing_charge && updatedDeliverypayment?.payment_data?.packing_charge != 0 && <div className="d-flex  justify-content-between ">
                                                        <p className="m-0 p-0">Packing cost</p>
                                                        <p className="m-0 p-0">{updatedDeliverypayment?.payment_data?.packing_charge} </p>
                                                    </div>

                                                }

                                            </div>
                                            <div className="d-flex justify-content-end fs-14 border-topBtom-Dashed mt-2 ff-poppins-semiBold">
                                                <span className="py-2">Total {" "}- Rs.{(Number(updatedDeliverypayment?.payment_amount) + Number(deliverytipamt ? deliverytipamt : 0)).toFixed(2)}</span>
                                            </div>
                                        </div>
                                    }
                                    <div className='primary-bottom-btn rounded-3 mt-2 fs-14 ff-poppins-semiBold text-center'
                                        onClick={() => {
                                            if (seletedDeliverytype == 0 || seletedDeliverytype == 1) {
                                                updateInstore()
                                                setTimeout(() => {
                                                    confirmChangeDelivery()
                                                }, 200);
                                            }
                                            else if (seletedDeliverytype == 2) {
                                                if (updatedDeliverypayment) {
                                                    confirmChangeDelivery()
                                                } else {
                                                    if (deliverytype == "any") {
                                                        updateInstore();
                                                    } else if (deliverytype == '') {
                                                        handelSelectTime();
                                                        setDeliverytype("timeslot");
                                                    }
                                                }
                                            }
                                        }}
                                    >
                                        {updatedDeliverypayment ? 'Pay & Confirm' : 'Confirm'}
                                    </div>

                                    {userLocationListModal &&
                                        <>
                                            <div className="modalBackdrop locationListBackdrop " ></div>
                                            <div className={`offcanvas offcanvas-bottom-modal locationListModal ${userLocationListModal ? 'show ' : ''}`} >

                                                <div className="">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="ff-poppins-semiBold"> Choose address </div>
                                                        <div onClick={() => setUserLocationListModal(!userLocationListModal)}>
                                                            <IoMdClose />
                                                        </div>
                                                    </div>
                                                    {userLocation?.length > 0 ?
                                                        <div className="d-flex flex-column mt-2">
                                                            {
                                                                userLocation.map((location, index) => {
                                                                    return (
                                                                        <div onClick={() => location.select_status ? selectLocation(location)
                                                                            :
                                                                            showToast(`Doorstep delivery available only ${" "} within ${data.delivery_radius_distance}km`)}
                                                                            className="border-bottom border-dark-subtle px-2 py-2" >
                                                                            <div className="d-flex align-items-center" style={{ opacity: location.select_status == 0 ? 0.4 : 1 }} >
                                                                                <div className="col-2">
                                                                                    <div className="border w-100 border-black border-opacity-10 rounded d-flex justify-content-center fs-24 primary-text py-2">
                                                                                        {location.location_type_id == 1 ? (
                                                                                            <IoMdHome className="primary-text" />
                                                                                        ) : location.location_type_id == 2 ? (
                                                                                            <MdWork className="primary-text" />
                                                                                        ) : (
                                                                                            <IoLocationSharp />
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-9">
                                                                                    <p className="m-0 ps-3 ff-poppins-bold">
                                                                                        {location.location_type}{" "}
                                                                                    </p>
                                                                                    <p className="m-0 ps-3 ff-poppins-regular fs-12">
                                                                                        {
                                                                                            location.address.length > 30
                                                                                                ? `${location.address.slice(0, 38)}...`
                                                                                                : location.address

                                                                                        }
                                                                                        <span className="ms-2"> {location?.distance?.text} - {location?.duration?.text}</span>
                                                                                    </p>

                                                                                </div>
                                                                                <div className="col-1">
                                                                                    <IoIosArrowForward />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                        :
                                                        <div className="emptyAddressBox">
                                                            <span>No address added yet</span>
                                                        </div>
                                                    }
                                                    <div onClick={() => { navigate("/AddDeliveryAddress", { state: { fromPage: 'products' } }); }} className="border-bottom border-secondary-subtle p-2 mt-2 mb-2">
                                                        <div className="d-flex align-items-center">
                                                            <div className="col-2">
                                                                <div className="border w-100 border-dark-subtle  border-opacity-10 d-flex justify-content-center fs-24 primary-text py-2">
                                                                    <FaRegSquarePlus />
                                                                </div>
                                                            </div>
                                                            <div className="col-9">
                                                                <p className="m-0 ps-3 ff-poppins-bold primary-text">Add New Address</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </>
                                    }

                                    {deliveryOptionModal &&
                                        <>
                                            <div className="modalBackdrop" style={{ zIndex: 1055 }} ></div>

                                            <div className={`offcanvas offcanvas-bottom-modal ${deliveryOptionModal ? 'show ' : ''}`} style={{ zIndex: 1060 }}>
                                                <div className="modal-container gap-2">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="modalBackbtn" onClick={() => setDeliveryOptionModal(!deliveryOptionModal)}   >
                                                            <IoChevronBack className="modalCloseicon" />
                                                            <span className="ms-1">Back</span>
                                                        </div>
                                                        <div className="modalClosebtn" onClick={() => setDeliveryOptionModal(!deliveryOptionModal)}     >
                                                            <IoMdClose className="modalCloseicon" />
                                                        </div>

                                                    </div>
                                                    <div className="d-flex align-items-center m-0 p-0">
                                                        <div>
                                                            <p className="p-0 m-0 ff-poppins-semiBold fs-14 text-dark">Choose Delivery Options</p>
                                                            <p className="m-0 p-0 ff-poppins-medium fs-11 secondary-text-2 ">Choose timeslot when order will be delivered</p>
                                                        </div>
                                                    </div>
                                                    <div className="custom-scroll d-flex flex-column gap-2">
                                                        <div >
                                                            <div className={`${deliverySettings?.slot_delivery_status == 2 ? 'opacity_Cls' : deliverytype == "slot" ? "primary-box primary-text" : "secondary-box"} rounded-3`}>
                                                                <div
                                                                    className="d-flex justify-content-between align-items-center p-2 delivery-option-item"
                                                                    onClick={() => {
                                                                        // if (data?.delivery_settings?.slot_delivery_status === 2) {
                                                                        //     showToast(data?.delivery_settings?.slot_delivery_msg);
                                                                        //     return;
                                                                        // }

                                                                        // setDeliverytype("slot");
                                                                        // closeDeliveryoptionModal();
                                                                        setSlotdeliveryModal(!slotdeliveryModal)
                                                                    }}
                                                                >
                                                                    {/* LEFT SIDE */}
                                                                    <div className="d-flex align-items-center">
                                                                        <div className="ms-2">
                                                                            <h6 className="fs-13 m-0 ff-poppins-semiBold">
                                                                                Slot Delivery
                                                                            </h6>
                                                                            <p className="fs-10 m-0 ff-poppins-medium text-muted">
                                                                                Delivered right on time, in your chosen slot!
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex align-items-center gap-2">
                                                                        {deliverySettings?.slot_delivery_charge && (
                                                                            <div className="fs-12 ff-poppins-semiBold mt-1">
                                                                                <span className="rupeeIcon">₹</span>{deliverySettings?.slot_delivery_charge}
                                                                            </div>
                                                                        )}

                                                                        <MdArrowForwardIos size={14} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {
                                                                deliverySettings?.instant_delivery_status == "1" || deliverySettings?.own_instant_delivery_status == "1" ?
                                                                    <div className={`${deliverySettings?.instant_delivery_status == 2 ? 'opacity_Cls' : deliverytype == "instant" ? "primary-box primary-text" : "secondary-box"} rounded-3 mt-2 mb-2`}>
                                                                        <div className="d-flex justify-content-between align-items-center p-2" onClick={() => {
                                                                            if (deliverySettings?.instant_delivery_status == 2) {
                                                                                showToast(deliverySettings?.instant_delivery_msg)
                                                                                return;
                                                                            } else { setDeliverytype("instant") }
                                                                        }}>
                                                                            <div className="d-flex align-items-center">
                                                                                {
                                                                                    deliverytype == "instant" ?
                                                                                        <img src={select_circle} height="25px" width="25px" /> :
                                                                                        <img src={unselect_circle} height="25px" width="25px" />
                                                                                }
                                                                                <div className="ms-3">
                                                                                    <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">Instant Delivery</h6>
                                                                                    <p className="fs-10 p-0 m-0 ff-poppins-regular ">Delivered to you in just 30 minutes!</p>
                                                                                </div>
                                                                            </div>
                                                                            {deliverySettings?.instant_delivery_charge &&
                                                                                <div className="fs-13 ff-poppins-semiBold">
                                                                                    <span className="rupeeIcon">₹</span>{deliverySettings?.instant_delivery_charge}
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div> : ""
                                                            }
                                                        </div>

                                                    </div>
                                                    <div>
                                                        <button className={`primary-bottom-btn  rounded-3 fs-14 ff-poppins-medium`}
                                                            onClick={() => {
                                                                if (deliverytype == "") {
                                                                    showToast("Please select a delivery type")
                                                                }
                                                                else if (deliverytype == "instant") {
                                                                    if (deliverySettings?.instant_delivery_status == 2) {
                                                                        showToast(`${deliverySettings?.instant_delivery_msg}..`);
                                                                    }
                                                                    else {
                                                                        updateInstore();
                                                                    }
                                                                } else if (deliverytype == "instore") {
                                                                    toggleDeliveryTypeOffCanvas()
                                                                }
                                                            }}
                                                        >
                                                            Continue
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {
                                        slotdeliveryModal &&
                                        <>
                                            <div className="lightmodalBackdrop" style={{ zIndex: 1070 }} ></div>
                                            <div className={`offcanvas offcanvas-bottom-modal ${slotdeliveryModal ? 'show ' : ''}`} style={{ zIndex: 1075 }}   >
                                                <div className=" ">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="p-0 m-0 fs-13 ff-poppins-semiBold text-dark" onClick={() => { setSlotdeliveryModal(!slotdeliveryModal) }}>
                                                            <span className=" " >
                                                                <IoChevronBack size={18} color="balck" className="me-1" />
                                                            </span>
                                                            <span >
                                                                Back
                                                            </span>
                                                        </div>
                                                        <span className="p-0 m-0 fs-20 ff-poppins-semiBold" onClick={() => setSlotdeliveryModal(!slotdeliveryModal)} ><IoMdClose /></span>
                                                    </div>

                                                    <div className="p-1">
                                                        <div className="mb-2">
                                                            <p className="ff-poppins-medium fs-14  text-dark p-0 m-0">Slot Delivery </p>
                                                            <p className="ff-poppins-medium fs-12 secondary-text-2 p-0 m-0">Choose timeslot when order will be delivered</p>
                                                        </div>
                                                        <div className="d-flex flex-column ">
                                                            <div className={`${deliverytype == "any" ? "primary-box primary-text" : "secondary-box"} rounded-3`}>
                                                                <div className="d-flex justify-content-between align-items-center p-2" onClick={() => { setDeliverytype("any"); }}>
                                                                    <div className="d-flex align-items-center">
                                                                        {
                                                                            deliverytype == "any" ?
                                                                                <img src={select_circle} height="25px" width="25px" /> :
                                                                                <img src={unselect_circle} height="25px" width="25px" />
                                                                        }
                                                                        <div className="ms-3">
                                                                            <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold"  >Any time</h6>
                                                                            <p className="fs-10 p-0 m-0 ff-poppins-regular ">Delivered anytime,once sent by the merchant!</p>
                                                                        </div>
                                                                    </div>
                                                                    {deliverySettings?.slot_delivery_charge &&
                                                                        <div className="fs-13 ff-poppins-semiBold">
                                                                            <span className="rupeeIcon">₹</span>{deliverySettings?.slot_delivery_charge}
                                                                        </div>}
                                                                </div>
                                                            </div>


                                                            <div className={`${deliverytype == "timeslot" ? "primary-box primary-text" : "secondary-box"} rounded-3 mt-2`}>
                                                                <div className="d-flex justify-content-between align-items-center p-2" onClick={() => { setDeliverytype("timeslot"); }} >
                                                                    <div className="d-flex align-items-center">
                                                                        {
                                                                            deliverytype == "timeslot" ?
                                                                                <img src={select_circle} height="25px" width="25px" /> :
                                                                                <img src={unselect_circle} height="25px" width="25px" />
                                                                        }
                                                                        <div className="ms-3">
                                                                            <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">Choose time slot</h6>
                                                                            <p className="fs-10 p-0 m-0 ff-poppins-regular ">Delivered right on time,in your chosen slot!</p>
                                                                        </div>
                                                                    </div>
                                                                    {deliverySettings?.slot_delivery_charge &&
                                                                        <div className="fs-13 ff-poppins-semiBold">
                                                                            <span className="rupeeIcon">₹</span>{deliverySettings?.slot_delivery_charge}
                                                                        </div>}
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className={`primary-bottom-btn rounded-3 mt-1 fs-14 ff-poppins-regular text-center mt-2`}
                                                        onClick={() => {
                                                            if (deliverytype == "any") {
                                                                SelectSlotDelivery("ANY");
                                                            } else {
                                                                handelSelectTime();
                                                                setDeliverytype("timeslot");
                                                            }
                                                        }}
                                                    >
                                                        Continue
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {
                                        showInstructionModal &&
                                        <div >
                                            <InstructionsNoteModal toggleshowInstruction={toggleshowInstruction} />
                                        </div>
                                    }

                                    {showDatePickerModal && (
                                        <DeliveryTime_Slot
                                            isOpen={isDatePickerOffCanvasOpen}
                                            toggleOffCanvas={toggleDatePickerOffCanvas}
                                            vendorId={data?.vendor_id}
                                            shipingtype={seletedDeliverytype}
                                            fromPage={"productpass"}
                                        />
                                    )}
                                </div>
                            </div>


                        </div>
                    </div>

                </>

            }


        </>
    )
}


export default ChangeDeliverytypeOffcanvas;
